import { ModuleWithProviders, NgModule } from '@angular/core';
import { IDateConfig } from './model';
import { ToDatePipe, ToTimePipe } from './pipes';
import { DateUtil, dateServiceFactory } from './services';
import { DATE_CONFIG } from './tokens/date.token';

const DEFAULT_OPTIONS: IDateConfig = {
  format: 'DD/MM/YYYY',
  locale: 'he-IL'
};

@NgModule({
  imports: [ToDatePipe, ToTimePipe],
  providers: [ToDatePipe, ToTimePipe, { provide: DateUtil, useFactory: dateServiceFactory }],
  declarations: [],
  exports: []
})
export class DateUtilModule {
  static forRoot(dateOptions?: IDateConfig): ModuleWithProviders<DateUtilModule> {
    return {
      ngModule: DateUtilModule,
      providers: [
        { provide: DateUtil, useFactory: dateServiceFactory },
        {
          provide: DATE_CONFIG,
          useValue: { ...DEFAULT_OPTIONS, ...dateOptions }
        }
      ]
    };
  }
}
